import { render, staticRenderFns } from "./ex-swiper.vue?vue&type=template&id=7fc024a6&scoped=true&"
import script from "./ex-swiper.vue?vue&type=script&lang=js&"
export * from "./ex-swiper.vue?vue&type=script&lang=js&"
import style0 from "./ex-swiper.vue?vue&type=style&index=0&id=7fc024a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc024a6",
  null
  
)

export default component.exports